module.exports = __webpack_public_path__ + "media/AG-Digital.d3a7bb8a.mp4";